export const ForumBox = [
  {
    title: "PSG FANS",
    count: 13,
    type: "Public"
  },
  {
    title: "FootballUpdates",
    count: 43,
    type: "Public"
  },
  {
    title: "NBA",
    count: 47,
    type: "Public"
  },
  {
    title: "Chelsea Fan Club",
    count: 89,
    type: "Public"
  },
  {
    title: "Volley Ball",
    count: 17,
    type: "Public"
  },
  {
    title: "Football Academy",
    count: 34,
    type: "Private"
  },
  {
    title: "Volley Ball",
    count: 17,
    type: "Public"
  },
  {
    title: "Football Academy",
    count: 34,
    type: "Private"
  },
];

export const content = [
  {
    title: "#Barcelona",
    type: "regular"
  },
  {
    title: "#RealMadrid"
  },
  {
    title: "#Arsenal",
    type: "regular"
  },
  {
    title: "#Mancity"
  },
  {
    title: "#Ronaldo",
    type: "regular"
  },
  {
    title: "#SerenaWilliams"
  },
  {
    title: "#KunAguero",
    type: "regular"
  },
  {
    title: "#Barcelona",
    type: "regular"
  },
  {
    title: "#RealMadrid"
  },
  {
    title: "#Arsenal",
    type: "regular"
  },
  {
    title: "#ManchesterUnited"
  },
  {
    title: "#MichealJordan"
  },
  {
    title: "#Mancity"
  },
  {
    title: "#Ronaldo",
    type: "regular"
  },
  {
    title: "#SerenaWilliams"
  },
  {
    title: "#KunAguero",
    type: "regular"
  },
  {
    title: "#Barcelona",
    type: "regular"
  },
  {
    title: "#RealMadrid"
  },
  {
    title: "#Arsenal",
    type: "regular"
  },
  {
    title: "#ChristianoR7",
    type: "regular"
  },
  {
    title: "#Mancity"
  },
  {
    title: "#Cricket"
  }
];